const DataByPlayer = [
    {
        playerId: '1',
        name: 'Player 1',
        military: 0,
        armada: 0,
        coins: 0,
        wonders: 0,
        blue: 0,
        yellow: 0,
        green: 0,
        purple: 0,
        boats: 0,
        leaders: 0,
        black: 0,
        total: 0
    },
    {
        playerId: '2',
        name: 'Player 2',
        military: 0,
        armada: 0,
        coins: 0,
        wonders: 0,
        blue: 0,
        yellow: 0,
        green: 0,
        purple: 0,
        boats: 0,
        leaders: 0,
        black: 0,
        total: 0
    },
    {
        playerId: '3',
        name: 'Player 3',
        military: 0,
        armada: 0,
        coins: 0,
        wonders: 0,
        blue: 0,
        yellow: 0,
        green: 0,
        purple: 0,
        boats: 0,
        leaders: 0,
        black: 0,
        total: 0
    },
    {
        playerId: '4',
        name: 'Player 4',
        military: 0,
        armada: 0,
        coins: 0,
        wonders: 0,
        blue: 0,
        yellow: 0,
        green: 0,
        purple: 0,
        boats: 0,
        leaders: 0,
        black: 0,
        total: 0
    },
    {
        playerId: '5',
        name: 'Player 5',
        military: 0,
        armada: 0,
        coins: 0,
        wonders: 0,
        blue: 0,
        yellow: 0,
        green: 0,
        purple: 0,
        boats: 0,
        leaders: 0,
        black: 0,
        total: 0
    },
    {
        playerId: '6',
        name: 'Player 6',
        military: 0,
        armada: 0,
        coins: 0,
        wonders: 0,
        blue: 0,
        yellow: 0,
        green: 0,
        purple: 0,
        boats: 0,
        leaders: 0,
        black: 0,
        total: 0
    },
    {
        playerId: '7',
        name: 'Player 7',
        military: 0,
        armada: 0,
        coins: 0,
        wonders: 0,
        blue: 0,
        yellow: 0,
        green: 0,
        purple: 0,
        boats: 0,
        leaders: 0,
        black: 0,
        total: 0
    }
];

export const player1Data = {
    playerId: '1',
    name: 'Player 1',
    military: 100,
    armada: 0,
    coins: 0,
    wonders: 0,
    blue: 0,
    yellow: 0,
    green: 0,
    purple: 0,
    boats: 0,
    leaders: 0,
    black: 0,
    total: 0
}

export default DataByPlayer;